import { render } from 'preact';
import { App } from '@/app';
import { initTheme } from '@/lib/theme';
import { initOutbox } from '@/lib/outbox';
import { initSync } from '@/lib/sync';
import { initAlarms } from '@/lib/alarms';
import { reloadFromCache } from '@/state/data';
import { session } from '@/lib/supabase';
import { effect } from '@preact/signals';
import '@/styles/tokens.css';
import '@/styles/shell.css';
import '@/styles/chat.css';
import '@/styles/now.css';
import '@/styles/roster.css';
import '@/styles/calendar.css';
import '@/styles/photos.css';
import '@/styles/reports.css';

initTheme();
void reloadFromCache(); // paint instantly from the local cache

// Network/data services start once we know we're signed in.
let servicesStarted = false;
effect(() => {
  if (session.value && !servicesStarted) {
    servicesStarted = true;
    initOutbox();
    initSync();
    initAlarms();
  }
});

render(<App />, document.getElementById('app')!);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  import('virtual:pwa-register').then(({ registerSW }) => registerSW({ immediate: true }));
  void import('@/lib/push').then(({ initPushState }) => initPushState());
  // Notification taps land on the Now board.
  navigator.serviceWorker.addEventListener('message', (e) => {
    if (e.data?.type === 'notification-tap') {
      void import('@/state/nav').then(({ navigate }) => navigate('/now'));
    }
  });
}
